import { useEffect, useState } from "react";
import { Minus, Plus } from "lucide-react";
import { normalizeTime } from "@/components/shared/TimeField";

const toMin = (t) => { const [h, m] = String(t || "0:0").split(":").map(Number); return (h || 0) * 60 + (m || 0); };
const fmt = (m) => `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;

// 422: čas v okně směny — −/+ po 15 minutách a zároveň jde napsat číslicemi
// („1252“, „12:52“, „7“ = 07:00). Enter nebo odklepnutí potvrdí, Esc vrátí původní.
export function TimeStepper({ value, onChange, label, testid, changed = false }) {
  const [text, setText] = useState(value || "");
  useEffect(() => { setText(value || ""); }, [value]);
  const shift = (d) => onChange(fmt(Math.max(0, Math.min(1439, toMin(value) + d))));
  const commit = () => {
    const n = normalizeTime(text);
    if (n && n !== value) onChange(n);
    else setText(value || "");
  };
  const btn = "h-11 w-11 shrink-0 rounded-full border border-border bg-card grid place-items-center hover:bg-secondary transition-colors";
  return (
    <span className="inline-flex items-center gap-2" data-testid={testid}>
      <button type="button" onClick={() => shift(-15)} aria-label={`${label} o 15 minut dřív`} data-testid={`${testid}-minus`} className={btn}><Minus size={18} /></button>
      <input value={text} onChange={(e) => setText(e.target.value)} onBlur={commit} data-inline-edit inputMode="numeric" autoComplete="off"
        onKeyDown={(e) => {
          if (e.key === "Enter") { e.preventDefault(); commit(); e.currentTarget.blur(); }
          if (e.key === "Escape") { setText(value || ""); e.currentTarget.blur(); }
        }}
        aria-label={`${label}, napiš čas, třeba 1252 nebo 12:52`} title="Napiš čas, třeba 1252 nebo 12:52" data-testid={`${testid}-input`}
        className={`h-11 w-[92px] min-w-0 rounded-[12px] border border-border bg-card text-center text-[22px] font-black tabular-nums focus:outline-none focus:border-brand focus:ring-2 focus:ring-brand/20 ${changed ? "text-brand" : ""}`} />
      <button type="button" onClick={() => shift(15)} aria-label={`${label} o 15 minut později`} data-testid={`${testid}-plus`} className={btn}><Plus size={18} /></button>
    </span>
  );
}
